import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import CoachDashboard from "@/pages/CoachDashboard";
import AthleteDashboard from "@/pages/AthleteDashboard";
import Athletes from "@/pages/Athletes";
import Training from "@/pages/Training";
import Reports from "@/pages/Reports";
import Invites from "@/pages/Invites";

function Protected({ children, requireRole }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="w-10 h-10 border-4 border-zinc-800 border-t-[#FF3B30] rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireRole && user.role !== requireRole) {
    return <Navigate to={user.role === "tecnico" ? "/dashboard" : "/passaporte"} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "tecnico" ? "/dashboard" : "/passaporte"} replace />;
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Handle OAuth callback first (hash-based session_id) before other routes
  if (location.hash?.includes("session_id=") && location.pathname !== "/auth/callback") {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<Protected requireRole="tecnico"><CoachDashboard /></Protected>} />
      <Route path="/atletas" element={<Protected requireRole="tecnico"><Athletes /></Protected>} />
      <Route path="/atleta/:athleteId" element={<Protected><AthleteDashboard /></Protected>} />
      <Route path="/passaporte" element={<Protected><AthleteDashboard /></Protected>} />
      <Route path="/treino" element={<Protected><Training /></Protected>} />
      <Route path="/relatorios" element={<Protected requireRole="tecnico"><Reports /></Protected>} />
      <Route path="/convites" element={<Protected requireRole="tecnico"><Invites /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}
